module.exports = __webpack_public_path__ + "img/流体力学4_6_4.54d05078.jpg";